import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import LoginHeader from "./components/LoginHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import ReportsCarousel from "./ReportsCarousel";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import ReportTable from "./ReportTable.js";
import Links from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AADHeader from "./components/AADHeader.js";
const Standards = () => {
  const [isOpen, setIsOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(false);

  const getOpen = (open) => {
    setIsOpen(open);
  };
  const renderHeader = () => {
    const loginType = localStorage.getItem('loginType');
    if (loginType === 'AAD') {
      return <AADHeader />;
    }
    return <LoginHeader heading="" />;
  };
  return (
    <div id="wrapper">
      <div>
        {loading && (
          <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true}>
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
      </div>
      <div id="sidebar-wrapper" className={isOpen ? "sidebar-open" : "sidebar-close"}>
        <SideNavigation getOpen={getOpen} />
      </div>
      <div id="page-content-wrapper" className={isOpen ? "" : "page-content-wrapper-pd-0"}>
      {renderHeader()}
        <div class="container formpd">
          <div class="flex justify-content-between">
            <div class="steps__containt-hader">
              <h3 class="title">Standards & Frameworks</h3>
              <div role="presentation">
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Link underline="hover" color="inherit" href="/standards">
                    Reports
                  </Link>
                  <Typography color="text.primary">Standards & Frameworks</Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="standards-ct">
            <div class="col-md-12 flex pd-0">
              <h2>Start a new report with built-in frameworks</h2>
            </div>
            <ReportsCarousel />
            <div class="col-md-12 flex pd-0 pt-20">
            <h2 style={{ marginTop: "30px" }}>Existing Reports</h2>
            </div>
            <ReportTable />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Standards;
